import { useRef } from 'react';
import { useLocation } from 'react-router';
import { TB_DRAFT_STATE, type TrialBalanceDraftHeader } from '@/core/models/trial-balance.models';
import { openDialog } from '@/kit/dialog';
import { TrialBalanceDialog, type TrialBalanceDialogData, type TrialBalanceDialogResult } from './TrialBalanceDialog';

/**
 * BUG-037: the details confirmed in Create Trial Balance, as the list passed them to the editor (router state). The
 * editor creates the trial balance from them when it is saved (BUG-036: its Save button).
 */
export function useTrialBalanceDraft() {
  const location = useLocation();
  const state = location.state as Record<string, unknown> | null;
  return useRef<TrialBalanceDraftHeader | null>(
    (state?.[TB_DRAFT_STATE] as TrialBalanceDraftHeader | undefined) ?? null,
  );
}

/**
 * BUG-037: the editor was opened for a new trial balance without confirmed details (the header's "New trial balance",
 * a direct link): ask for them with the same Create Trial Balance dialog, so the Period and Mode of Import are always the
 * user's choice. Resolves null when the user cancels. BUG-036: a file's lines come back on the draft, unsaved. BUG-038:
 * a Bookkeeping import resolves the trial balance it created.
 */
export async function askForTrialBalanceDetails(clientId: string): Promise<TrialBalanceDialogResult | null> {
  const data: TrialBalanceDialogData = { clientId };
  const result = await openDialog<TrialBalanceDialogData, TrialBalanceDialogResult>(TrialBalanceDialog, {
    disableClose: true,
    panelClass: 'cst-invite',
    data,
  }).afterClosed();
  return result ?? null;
}

/** BUG-037: what Save of a new trial balance with no account line says (nothing is created). */
export const NO_LINES_MESSAGE = 'Enter at least one account line before saving the trial balance.';
